/**
 * Compute the progress (in %) from the mouse position.
 * @param mouseXPos - Position of the mouse on the X axis.
 * @param containerBoundaries - The wrapper element of the thumb.
 * @param duration - Duration of the audio.
 * @returns
 */
export var convertPositionToSec = function convertPositionToSec(mouseXPos, _ref, duration) {
  var width = _ref.width,
      left = _ref.left;
  if (!width || left === undefined) return 0; // zero is valid only for the left parameter

  var relativePos = mouseXPos - left; // We need to restrict the mouse position to the audio time.

  var percentage = Math.max(0, Math.min(1, relativePos / width));
  return percentage * duration;
};
export var getPercentage = function getPercentage(value, total) {
  return total > 0 ? value * 100 / total : 0;
}; // Dividing with zero returns NaN